import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  FormGroup,
  ControlLabel,
  FormControl,
} from "react-bootstrap";

import Card from "components/Card/Card.jsx";
import Datetime from "react-datetime";
import Checkbox from "components/CustomCheckbox/CustomCheckbox.jsx";

import Button from "components/CustomButton/CustomButton.jsx";
import Radio from "components/CustomRadio/CustomRadio.jsx";
import { addNewGroup } from "../../../Listfunction";
import NotificationSystem from "react-notification-system";
import { style } from "../../../variables/Variables";
import InputColor from "react-input-color";
import axios from "axios";

class AddGroup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      status: "1",
      grouptitle: "",
      grouptitleError: null,
      group_icon_url: "",
      group_icon_urlError: null,
      oldGroupIconfile: "",
      group_icon: "",
      group_icon_data: "",
      errormessages: [],
      is_MBE: false,
      is_Push_Notification : false,
      checkboxerr : ''
    };
    this.onSubmit = this.onSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
    this.handlegroup_iconFileChange = this.handlegroup_iconFileChange.bind(this);
  }

  handlegroup_iconFileChange(event) {
    this.setState({ group_icon: event.target.files[0] });
  }

  uploadgroup_icon() {
    document.getElementById("selectgroup_icon").click();
  }


  handleSuccess(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "success";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Lead group</b> - Added Successfully .
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
    setTimeout(() => {
      this.props.history.push("/admin/groups");
    }, 3000);
  }
  handleNetworkError(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Network Error</b>.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }
  handleClick(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>something went wrong</b>.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }

  async componentDidMount() {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    this.setState({ _notificationSystem: this.refs.notificationSystem });
    setTimeout(
      function () {
        this.setState({ cardHidden: false });
      }.bind(this),
      700
    );
  }
  onChange = (event) => {
    const target = event.target;
    const value = target.type === "select" ? target.selected : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  };
  async onSubmit () {
    this.setState({ errormessages: [] });
    let error = false;
    if (this.state.grouptitle.length == 0) {
      error = true;
      this.setState({
        grouptitleError: (
          <small className="text-danger">Title is required.</small>
        ),
      });
    } else {
      this.setState({ grouptitleError: null });
    }

    if (this.state.is_Push_Notification == false && this.state.is_MBE == false) {
      // error = true;
      // this.setState({
      //   checkboxerr : (
      //     <small className="text-danger">Please select group type</small>
      //   ),
      // });
    } else {
      this.setState({ checkboxerr: null });
    }

    if (!error) {
      var token = JSON.parse(localStorage.getItem("user"));
      const obj = token.token;
      var is_flash_coupon = 1;
      var is_active = 1;
      var CouponCode = "";
      {
        if (this.state.is_flash_coupon) {
          CouponCode = "";
        } else {
          CouponCode = this.state.coupon_code;
        }
      }
      CouponCode = this.state.coupon_code;

      if (this.state.group_icon.length != 0) {
        this.setState({ processing: true });

        const fdata = new FormData();
        fdata.append("icon_file", this.state.group_icon);
        let url =
          process.env.REACT_APP_NOT_SECRET_CODE + "/leads/group/icon";
        await axios
          .post(url, fdata, {
            headers: {
              Authorization: "Bearer " + obj,
              "X-Country-Code": "BD",
              "X-Client-Name": "WEBSITE",
              "X-Client-Version": "123",
              "Content-Type": "application/json",
              "X-Request-Id": "124",
            },
          })
          .then((res) => {
            this.setState({ group_icon_data: res.data.data.group_icon_url });
          });
      } else {
        this.setState({ group_icon_data: this.state.oldGroupIconfile });
      }

      var is_visible_in_mbe  = 0
      var is_visible_in_bulk_pn = 0
      if(this.state.is_MBE)
      {
        is_visible_in_mbe = 1
      }

      if(this.state.is_Push_Notification)
      {
        is_visible_in_bulk_pn = 1
      }



      addNewGroup(
        this.state.grouptitle, 
        this.state.group_icon_data,
        is_visible_in_mbe,
        is_visible_in_bulk_pn, 
        obj)
        .then((res) => {
          if (res.data.success === false) {
            let message = res.data.data;
          } else if (res.data.success === true) {
            this.handleSuccess("bl");
          }
        })
        .catch((error) => {
          this.handleNetworkError("bl");
          console.log(error, "== error");
        });
    }
  };

  subEligibility = (e) => {
    var checked =  e.target.checked
    var name = e.target.name
    console.log(e.target.name) 
    if(name == 'is_MBE')
    {
      this.setState({ is_MBE : checked,checkboxerr : ''  });
    }
    else if(name == 'is_Push_Notification')
    {
      this.setState({ is_Push_Notification : checked,checkboxerr : ''  });
    }       
  }


  render() {
    const errormessages = this.state.errormessages;
    return (
      <div className="main-content">
        <input
          style={{ width: "0px", height: "0px", border: "none" }}
          type="text"
          ref={this.coupon_code_error}
        />
        <Grid fluid>
          <NotificationSystem ref="notificationSystem" style={style} />

          <Row>
            <Col md={6}>
              <Card
                content={
                  <form>
                    {errormessages.length != 0 && (
                      <div className=" alert alert-danger">
                        {errormessages.map((data) => (
                          <React.Fragment>
                            <li>{data}</li>
                          </React.Fragment>
                        ))}
                      </div>
                    )}

                    <FormGroup>
                      <ControlLabel>Group Title</ControlLabel>
                      <FormControl
                        name="grouptitle"
                        value={this.state.grouptitle}
                        onChange={(event) => {
                          this.setState({ grouptitle: event.target.value });
                          event.target.value === ""
                            ? this.setState({
                                grouptitleError: (
                                  <small className="text-danger">
                                    Group Title is required.
                                  </small>
                                ),
                              })
                            : this.setState({ grouptitleError: null });
                        }}
                        placeholder="Enter Group Title"
                        type="text"
                      />
                      {this.state.grouptitleError}
                    </FormGroup>

                    <FormGroup>
                      <ControlLabel>Group Icon</ControlLabel>
                      <br></br>

                      <input
                        style={{ display: "none" }}
                        id="selectgroup_icon"
                        type="file"
                        className="form-control"
                        name="group_icon"
                        onChange={this.handlegroup_iconFileChange}
                      />
                      <Button
                        onClick={this.uploadgroup_icon}
                        style={{ color: "#2B3A41" }}
                      >
                        {" "}
                        <i
                          className={
                            this.state.group_icon == ""
                              ? "fa fa-plus"
                              : "fa fa-pencil fa-fw"
                          }
                        ></i>{" "}
                        {this.state.group_icon == ""
                          ? "Choose Group Icon"
                          : "Change Group Icon"}
                      </Button>
                    </FormGroup>

                    <FormGroup>
                      <ControlLabel>Group Type</ControlLabel>
                        <div className="Group_type_detail">
                            <Checkbox number="146" checked={this.state.is_MBE} name="is_MBE" onChange={e => this.subEligibility(e)} label="MBE" ></Checkbox>
                            <Checkbox number="147" checked={this.state.is_Push_Notification} name="is_Push_Notification" onChange={e =>this.subEligibility(e)} label="Push Notification" ></Checkbox>
                        </div>
                        {
                          this.state.checkboxerr
                        }
                    </FormGroup>

                    <Button
                      onClick={this.onSubmit.bind(this)}
                      className="btn-color" //bsStyle="info"
                      fill
                    >
                      Submit
                    </Button>
                  </form>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default AddGroup;
